import React, { Component } from 'react';
import Base from '../BaseComponent'

import preloader  from 'preloader';
import withData from '../../utils/withData';


const HASLOADED = 0;

class Loader extends Component {

  constructor(props) {
    super(props);
    this.state = {loaded:0,progress:0};
  }

  componentDidMount() {
    
    const _this = this;
    let loader = preloader({
      xhrImages: false
    });

    let load = 0;
    let loaded = 0;
    let progress = 0;

    loader.on('progress',function(progress) {
        loaded++;
        progress = loaded / load;
        
         _this.setState({progress:progress});
    });

    loader.on('complete',function() {


      let store = {};
      _this.props.manifest.forEach((i) => {

        let src = (i.src) ? i.src : i;
        let label = (i.name) ? i.name : i;

        let content = loader.get(src);

        let toSave = (i.subset) ? content[i.subset] : content;
        store[label] = toSave;

        _this.props.datastore.store(label,store[label],false); // false flag - don't publish

    });
      
      _this.props.datastore.publish(); // Send one publish event
      _this.setState({progress:1,loaded:1});


    });

    this.props.manifest.forEach((i) => {

        load++;
        let src = (i.src) ? i.src : i;
        loader.add(i.src);
  

    });

    loader.load();



  }

  componentWillUnmount() {

  }

  


    

  /*
    
    RENDER

  */

  render() {

    //let content = (this.state.loaded) ? this.props.children : this.state.progress;

    if(this.state.loaded){
      return this.props.children
    }

    return (
      <Base family="Loader">
          {this.state.progress * 100}%
      </Base>
    );

  }
}



export default withData(Loader);



// WEBPACK FOOTER //
// ./src/js/components/Loader/Loader.jsx